import {Component, ViewEncapsulation} from '@angular/core';

@Component({
    templateUrl: './custom-dcp-configurator-single-page-form.component.html',
    styleUrl: './custom-dcp-configurator-single-page-form.component.scss',
    encapsulation: ViewEncapsulation.None
})
export class CustomDcpConfiguratorSinglePageFormComponent {
    hideConfiguration: boolean = false;
}
